import React, { useEffect,useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Signup from './components/signup/Signup.jsx';
import Dashboard from './components/dashboard/Dashboard.jsx';
import DriverDetails from './components/driverDetails/driverDetails.jsx';
import Vehicles from './components/vehicle/vehicle.jsx';
import DashboardCustomer from './components/dashboardCustomer/mainCustomer.jsx';
import DriverDocuments from './components/driverDocuments/driverDocuments.jsx';
import HomeScreenSettings from './components/homeScreenSettings/homeScreenSettings.jsx';
import HomeScreenDetails from './components/homeScreenSettings/homeScreenDetails.jsx';
import Fleets from './components/fleet/Fleet.jsx';
import Geofence from './components/geofence/Geofence.jsx';
import Corporate from './components/corporate/Corporate.jsx';
import ManagerSettings from './components/managerSettings/managerSettings.jsx';
import DynamicRidesPanel from './components/DynamicPanel/dynamicPanel.jsx';
import mainDashboard from './components/mainDashboard/mainDashboard.jsx';
import ScheduleRideSettings from './components/settingsScheduleRide/ScheduleRideSettings.jsx';
import SurgePricing from './components/surgePricing/SurgePricing.jsx';
import CustomZone from './components/customZone/customeZone.jsx';
import Dispatcher from './components/dispatcher/Dispatcher.jsx';
import DynamicAnalyticsReports from './components/analytics/analtyics.jsx';
import Layout from './Layout.jsx';
import GeneralSettings from './components/generalSettings/GeneralSettings.jsx';
import CitySettings from './components/citySettings/CitySettings.jsx';
import mapView from './components/mapView/MapView.jsx';
import Promotions from './components/promotions/Promotions.jsx';
import ShuttleStops from './components/shuttleStops/ShuttleStops.jsx';
import ShuttleRoutes from './components/shuttleRoutes/ShuttleRoutes.jsx';
import ShuttleFare from './components/shuttleFare/ShuttleFare.jsx';
import ShuttleCancellation from './components/shuttleCancellation/ShuttleCancellation.jsx';
import ShuttleSubscription from './components/shuttleSubscription/ShuttleSubscription.jsx';
import ShuttleVehicle from './components/shuttleVehicle/ShuttleVehicle.jsx';
import ShuttleJourney from './components/shuttleJourney/ShuttleJourney.jsx';
import ShuttleSeatStructure from './components/shuttleVehicle/ShuttleSeatStructure.jsx';
import ShuttleBooking from './components/shuttleBooking/ShuttleBooking.jsx';
import TripBookingDetails from './components/shuttleJourney/TripBookingDetails.jsx';
import OperationalCities from './components/operationalCities/OperationalCities.jsx';
import AddCity from './components/operationalCities/AddCity.jsx';
import VehicleInformation from './components/vehicleInfo/VehicleInformation.jsx';
import RecoverPassword from './components/recoverPassword/RecoverPassword.jsx';
import Pushes from './components/pushes/Pushes.jsx';
import ShuttleMapViewDetails from './components/shuttleMapViewDetails/ShuttleMapViewDetails.jsx';
import PushHistory from './components/pushHistory/PushHistory.jsx';
import ShuttleCancelReasons from './components/shuttleCancellationReasons/ShuttleCancelReasons.jsx';
import TmsClient from './components/tms_client/Client.jsx';
import TmsHelper from './components/tms_helpers/Helpers.jsx';
import TmsTruckVendors from './components/tms_truck_vendors/TruckVendors.jsx';
import TmsLocations from './components/tms_locations/Locations.jsx';
import TmsChassis from './components/tms_chassis/Chassis.jsx';
import TmsInspection from './components/tms_inspection/Inspection.jsx';
import TmsBooking from './components/tms_booking/TmsBooking.jsx';
import TmsTruckhead from './components/tms_truckhead/TruckHead.jsx';
import Assigned from './components/tms_dispatch/Assigned.jsx';
import Unassigned from './components/tms_dispatch/Unassigned.jsx';  
import Cancelled from './components/tms_dispatch/Cancelled.jsx';
import Ongoing from './components/tms_dispatch/Ongoing.jsx';
import FoulTrip from './components/tms_dispatch/FoulTrips.jsx';
import Delivered from './components/tms_dispatch/Delivered.jsx';
import BookingSettings from './components/tmsBookingSettings/BookingSettings.jsx';
import AirportTransferBooking from './components/airportTransferBooking/Booking.jsx';
import ClockTower from './components/tmsClockTower/ClockTower.jsx';
import ClockTowerDetails from './components/tmsClockTower/ClockTowerDetails.jsx';
import TmsDashboard from './components/tms_dashboard/TmsDashboard.jsx';
import RolesAndPermissions from './components/roles_and_permissions/RolesAndPermissions.jsx';
import AtCancelledTrips from './components/atBookingTrips/CancelledTrip.jsx';
import AtAssignedTrips from './components/atBookingTrips/AssignedTrips.jsx';
import AtCompletedTrips from './components/atBookingTrips/CompletedTrip.jsx';
import AtNoShowTrips from './components/atBookingTrips/NoShowTrip.jsx';
import AtOngoingTrip from './components/atBookingTrips/OngoingTrips.jsx';
import AtDashboard from './components/atDashboard/AtDashboard.jsx';
import FuelConsumption from './components/fuelConsumption/FuelConsumption.jsx';
import AtAllBookings from './components/airportTransferBooking/AllBookings.jsx';
import DeleteAccount from './components/deleteaccountrequest/deleteAccount.jsx';
import Address from './components/AddressSettings/Address.jsx';
import ManualTrips from './components/manualTripsData/ManualTrips.jsx';
import SuggestedRoutes from './components/shuttleSuggestedRoutes/ShuttleSuggestedRoutes.jsx';
import TaxiCancellationPolicy from './components/taxiCancellation/CancellationPolicy.jsx';
import TaxiCancellationReason from './components/taxiCancellation/CancellationReason.jsx';
import ScheduledBookings from './components/scheduledBookings/ScheduledBookings.jsx';
import ReviewSuggestion from './components/reviewSuggestions/ReviewSuggestion.jsx';
import ShuttlePromotions from './components/shuttlePromotions/ShuttlePromotions.jsx';
import ShuttleHoliday from './components/shuttleHoliday/ShuttleHoliday.jsx';
import ShiftTiming from './components/shiftTiming/ShiftTiming.jsx';
import ChatSuggestion from './components/ChatSuggestion/ChatSuggestion.jsx';
import DriverPayouts from './components/driverPayouts/DriverPayouts.jsx';
import Tab3Details from './components/shuttleBooking/Tab3Details.jsx';
import NotificationShow from './components/Notification/NotificationShow.jsx';
import DriverSubscription from './components/driverSubscription/DiverSubscription.jsx';
import DriverAnalysis from './components/driverSubscription/DriverAnalysis.jsx';
import CustomerDocs from './components/customerDocuments/CustomerDocs.jsx';
import CustomerDetails from './components/dashboardCustomer/CustomerDetails.jsx';
import MapViewPublic from './components/MapViewPublic/MapViewPublic.jsx';
import ShuttlePass from './components/shuttlePass/ShuttlePass.jsx';
import ParcelSettings from './components/parcelSettings/ParcelSettings.jsx';
import RequestedRides from './components/requestedRides/RequestedRides.jsx';
import NoShowSettings from './components/NoShowSettings/NoShowSettings.jsx';

import UserLogs from './components/Chat/userlogs.jsx';
import SupportChat from './components/Chat/supportchat.jsx';
// Root component with Router and GoogleMapsProvider
import { GoogleMapsProvider } from './utils/GoogleMapsLoader';
import PublicTrackingPage from './components/MapViewPublic/PublicTrackingPage.jsx';
import Partners from './components/partners/Partners.jsx';
import MissedRides from './components/missedRidesEngagements/MissedRides.jsx';
import ChangeDestination from './components/changeDestination/ChangeDestination.jsx';

const NotificationSetup = React.lazy(() =>
  import("./components/Notification/NotificationSetup")
);

function ProtectedRoute({ element: Component, ...rest }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const lastActivity = localStorage.getItem('lastActivity');
      const THIRTY_MINUTES = 30 * 60 * 1000; // 30 minutes in milliseconds

      if (!token) {
        setIsAuthenticated(false);
        navigate('/signup');
        return;
      }

      // Check if session is still valid
      if (lastActivity && (Date.now() - parseInt(lastActivity)) > THIRTY_MINUTES) {
        // Session expired
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        navigate('/signup');
        return;
      }

      // Update last activity time
      localStorage.setItem('lastActivity', Date.now().toString());
      setIsAuthenticated(true);
    };

    checkAuth();

    // Set up activity listeners
    const updateLastActivity = () => {
      if (localStorage.getItem('token')) {
        localStorage.setItem('lastActivity', Date.now().toString());
      }
    };

    const events = ['mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, updateLastActivity);
    });

    // Check auth status every minute
    const interval = setInterval(checkAuth, 60000);

    return () => {
      clearInterval(interval);
      events.forEach(event => {
        window.removeEventListener(event, updateLastActivity);
      });
    };
  }, [navigate]);

  if (isAuthenticated === null) {
    // Show loading state while checking auth
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/signup" replace />;
}

function App() {

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.playSound) {
                const audio = new Audio('/notificationsound.mp3');
                audio.play().catch(error => {
                    console.warn("Audio playback failed:", error);
                });
            }
        };

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', handleMessage);
        }

        return () => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('message', handleMessage);
            }
        };
    }, []);

    useEffect(() => {
    const checkInitialAuth = () => {
      const token = localStorage.getItem('token');
      const lastActivity = localStorage.getItem('lastActivity');
      const THIRTY_MINUTES = 30 * 60 * 1000;

      if (token && lastActivity && (Date.now() - parseInt(lastActivity)) < THIRTY_MINUTES) {
        // If we have a valid token and recent activity, update the last activity
        localStorage.setItem('lastActivity', Date.now().toString());
      }
    };

    checkInitialAuth();
  }, []);
  return (
    <div>
      <Routes>
        {/* Public route */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/recover-password" element={<RecoverPassword />} />
        <Route path="/livetracking" element={<PublicTrackingPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <GoogleMapsProvider>
              <Layout />
            </GoogleMapsProvider>
          }
        >
          <Route index element={<ProtectedRoute element={Dashboard} />} />        {/* driver page */}
          <Route path="/driver-details" element={<ProtectedRoute element={DriverDetails} />} />      {/* driver details page */}
          <Route path="/vehicle" element={<ProtectedRoute element={Vehicles} />} />
          <Route path="/driver-documents" element={<ProtectedRoute element={DriverDocuments} />} />
          <Route path="/homescreen-settings" element={<ProtectedRoute element={HomeScreenSettings} />} />
          <Route path="/homescreen-details" element={<ProtectedRoute element={HomeScreenDetails} />} />
          <Route path="/fleets" element={<ProtectedRoute element={Fleets} />} />
          <Route path="/geofence" element={<ProtectedRoute element={Geofence} />} />
          <Route path="/corporate" element={<ProtectedRoute element={Corporate} />} />
          <Route path="/manager_settings" element={<ProtectedRoute element={ManagerSettings} />} />
          {/* Dynamic route for ride statuses */}
          <Route path="/rides/:status" element={<ProtectedRoute element={DynamicRidesPanel} />} />
          <Route path="/rider-details" element={<ProtectedRoute element={DashboardCustomer} />} />    {/* customer page */}
          <Route path="/mainDashboard" element={<ProtectedRoute element={mainDashboard} />} />     {/* dashboard page */}
          <Route path="/settings/schedule-ride" element={<ProtectedRoute element={ScheduleRideSettings} />} />
          <Route path="/surge-pricing" element={<ProtectedRoute element={SurgePricing} />} />
          <Route path="/custom-zone" element={<ProtectedRoute element={CustomZone} />} />
          <Route path="/dispatcher" element={<ProtectedRoute element={Dispatcher} />} />
          <Route path="/analytics" element={<ProtectedRoute element={DynamicAnalyticsReports} />} />
          <Route path="/general_settings" element={<ProtectedRoute element={GeneralSettings} />} />
          <Route path="/city_settings" element={<ProtectedRoute element={CitySettings} />} />
          <Route path="/mapView" element={<ProtectedRoute element={mapView} />} />
          <Route path="/promotions" element={<ProtectedRoute element={Promotions} />} />
          <Route path="/shuttle-stops" element={<ProtectedRoute element={ShuttleStops} />} />
          <Route path="/shuttle-routes" element={<ProtectedRoute element={ShuttleRoutes} />} />
          <Route path="/shuttle-fare" element={<ProtectedRoute element={ShuttleFare} />} />
          <Route path="/shuttle-cancellation" element={<ProtectedRoute element={ShuttleCancellation} />} />
          <Route path="/shuttle-subscription" element={<ProtectedRoute element={ShuttleSubscription} />} />
          <Route path="/suggested-routes" element={<ProtectedRoute element={SuggestedRoutes} />} />
          <Route path="/shuttle-vehicle" element={<ProtectedRoute element={ShuttleVehicle} />} />
          <Route path="/shuttle-journey" element={<ProtectedRoute element={ShuttleJourney} />} />
          <Route path="/shuttle-holiday" element={<ProtectedRoute element={ShuttleHoliday} />} />
          <Route path="/shuttle-seat-structure" element={<ProtectedRoute element={ShuttleSeatStructure} />} />
          <Route path="/shuttle-booking" element={<ProtectedRoute element={ShuttleBooking} />} />
          <Route path="/shuttle-trip-booking-details" element={<ProtectedRoute element={TripBookingDetails} />} />
          <Route path="/operational-cities" element={<ProtectedRoute element={OperationalCities} />} />
          <Route path="/operational-cities/add-operational-city" element={<ProtectedRoute element={AddCity} />} />
          <Route path="/vehicle-information" element={<ProtectedRoute element={VehicleInformation} />} />
          <Route path="/pushes" element={<ProtectedRoute element={Pushes} />} />
          <Route path="/shuttle-map-details" element={<ProtectedRoute element={ShuttleMapViewDetails} />} />
          <Route path="/push-history" element={<ProtectedRoute element={PushHistory} />} />
          <Route path="/cancellation-reasons" element={<ProtectedRoute element={ShuttleCancelReasons} />} />
          <Route path="/tms-client" element={<ProtectedRoute element={TmsClient} />} />
          <Route path="/tms-helpers" element={<ProtectedRoute element={TmsHelper} />} />
          <Route path="/tms-locations" element={<ProtectedRoute element={TmsLocations} />} />
          <Route path="/tms-truck-vendors" element={<ProtectedRoute element={TmsTruckVendors} />} />
          <Route path="/tms-chassis" element={<ProtectedRoute element={TmsChassis} />} />
          <Route path="/inspection" element={<ProtectedRoute element={TmsInspection} />} />
          <Route path="/tms-booking" element={<ProtectedRoute element={TmsBooking} />} />
          <Route path="/delete-account" element={<ProtectedRoute element={DeleteAccount}/>}/>
          <Route path="/tms-truckhead" element={<ProtectedRoute element={TmsTruckhead} />} />
          <Route path="/tms-assigned-dispatch" element={<ProtectedRoute element={Assigned} />} />
          <Route path="/tms-unassigned-dispatch" element={<ProtectedRoute element={Unassigned} />} />
          <Route path="/tms-cancelled-dispatch" element={<ProtectedRoute element={Cancelled} />} />
          <Route path="/tms-ongoing-dispatch" element={<ProtectedRoute element={Ongoing} />} />
          <Route path="/tms-foul-dispatch" element={<ProtectedRoute element={FoulTrip} />} />
          <Route path="/tms-delivered-dispatch" element={<ProtectedRoute element={Delivered} />} />
          <Route path="/tms-booking-settings" element={<ProtectedRoute element={BookingSettings} />} />
          <Route path="/airport-transfer-booking" element={<ProtectedRoute element={AirportTransferBooking} />} />
          <Route path="/tms-clock-tower" element={<ProtectedRoute element={ClockTower} />} />
          <Route path="/clock-tower-details" element={<ProtectedRoute element={ClockTowerDetails} />} />
          <Route path="/tms-dashboard" element={<ProtectedRoute element={TmsDashboard} />} />
          <Route path="/roles_and_permissions" element={<ProtectedRoute element={RolesAndPermissions} />} />
          <Route path="/at-cancelled-trips" element={<ProtectedRoute element={AtCancelledTrips} />} />
          <Route path="/at-assigned-trips" element={<ProtectedRoute element={AtAssignedTrips} />} />
          <Route path="/at-completed-trips" element={<ProtectedRoute element={AtCompletedTrips} />} />  
          <Route path="/at-no-show-trips" element={<ProtectedRoute element={AtNoShowTrips} />} />
          <Route path="/at-ongoing-trips" element={<ProtectedRoute element={AtOngoingTrip} />} />
          <Route path="/at-dashboard" element={<ProtectedRoute element={AtDashboard} />} />
          <Route path="/fuel-consumption" element={<ProtectedRoute element={FuelConsumption} />} />
          <Route path="/all-bookings" element={<ProtectedRoute element={AtAllBookings} />} />
          <Route path="/address" element={<ProtectedRoute element={Address} />} />
          <Route path="/manual-trips" element={<ProtectedRoute element={ManualTrips} />} />
          <Route path="/taxi-cancellation-policy" element={<ProtectedRoute element={TaxiCancellationPolicy} />} />
          <Route path="/taxi-cancellation-reason" element={<ProtectedRoute element={TaxiCancellationReason} />} />
          <Route path="/scheduled-bookings" element={<ProtectedRoute element={ScheduledBookings} />} />
          <Route path="/review_suggestions" element={<ProtectedRoute element={ReviewSuggestion} />} />
          <Route path="/shuttle-promotions" element={<ProtectedRoute element={ShuttlePromotions} />} />
          <Route path="/shift-timing" element={<ProtectedRoute element={ShiftTiming} />} />
          <Route path="/chat-suggestions" element={<ProtectedRoute element={ChatSuggestion} />} />
          <Route path="/driver-payouts" element={<ProtectedRoute element={DriverPayouts} />} />
          <Route path="/driver-trip-details" element={<ProtectedRoute element={Tab3Details} />} />
          <Route path="/notification" element={<ProtectedRoute element={NotificationShow} />} />
          <Route path="/driver-subscription" element={<ProtectedRoute element={DriverSubscription} />} />
          <Route path="/driver-analysis" element={<ProtectedRoute element={DriverAnalysis} />} />
          <Route path="/customer-documents" element={<ProtectedRoute element={CustomerDocs} />} />
          <Route path="/customer-details" element={<ProtectedRoute element={CustomerDetails} />} />
          <Route path="/user-logs" element={<ProtectedRoute element={UserLogs} />} />
          <Route path="/support-chat" element={<ProtectedRoute element={SupportChat} />} />
          <Route path="/shuttle-pass" element={<ProtectedRoute element={ShuttlePass} />} />
          <Route path="/parcel-settings" element={<ProtectedRoute element={ParcelSettings} />} />
          <Route path="/requested-rides" element={<ProtectedRoute element={RequestedRides} />} />
            <Route path="/user-logs" element={<ProtectedRoute element={UserLogs} />} />
            <Route path="/support-chat" element={<ProtectedRoute element={SupportChat} />} />
            <Route path="/no-show-settings" element={<ProtectedRoute element={NoShowSettings} />} />
            <Route path="/partners" element={<ProtectedRoute element={Partners} />} />
            <Route path="/missed-rides" element={<ProtectedRoute element={MissedRides} />} />
            <Route path="/change-destination" element={<ProtectedRoute element={ChangeDestination} />} />

        </Route>
       
      </Routes>
    </div>
  );
}

function Root() {
  return (
    // <GoogleMapsProvider>
      <Router>
        <App />
        <React.Suspense fallback={null}>
          <NotificationSetup />
        </React.Suspense>
      </Router>
    // </GoogleMapsProvider>
  );
}

export default Root;
